/**
 * @fileoverview GET handler for the "/engagement/landing_pages/:app_group_id/size_limits" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementLandingPagesAppGroupIdSizeLimits } from "./constants";
import type { EngagementLandingPagesAppGroupIdSizeLimitsResult } from "./types";
import { isEngagementLandingPagesAppGroupIdSizeLimitsResult } from "./validators";

export const getEngagementLandingPagesAppGroupIdSizeLimits = reactQueryFetcherAdapter(
  engagementLandingPagesAppGroupIdSizeLimits,
  (signal: AbortSignal, appGroupId: string): Promise<EngagementLandingPagesAppGroupIdSizeLimitsResult> => {
    return fetch(`/engagement/landing_pages/${appGroupId}/size_limits`, "GET", {}, { signal });
  },
  isEngagementLandingPagesAppGroupIdSizeLimitsResult
);
